import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNodes, faArrowUp, faArrowDown, faEquals } from '@fortawesome/free-solid-svg-icons';

const TranscriptomeReport = ({ id, type, data }) => {
    // Placeholder data
    const transcriptomeData = data || {
        expressionProfile: {
            upregulated: 128,
            downregulated: 97,
            unchanged: 1843
        },
        significantGenes: [
            { gene: 'IL6', foldChange: 3.8, pValue: 0.0001, regulation: 'up', pathway: 'Inflammation' },
            { gene: 'TNF', foldChange: 2.5, pValue: 0.0008, regulation: 'up', pathway: 'Inflammation' },
            { gene: 'FOXP3', foldChange: -1.9, pValue: 0.0023, regulation: 'down', pathway: 'Immune regulation' },
            { gene: 'PPARG', foldChange: -2.3, pValue: 0.0015, regulation: 'down', pathway: 'Metabolism' },
            { gene: 'NRF2', foldChange: 1.7, pValue: 0.0047, regulation: 'up', pathway: 'Oxidative stress' }
        ],
        pathwayEnrichment: [
            { pathway: 'Inflammatory response', enrichmentScore: 4.8, pValue: 0.0003, genes: 12 },
            { pathway: 'Oxidative phosphorylation', enrichmentScore: 3.2, pValue: 0.0012, genes: 8 },
            { pathway: 'Lipid metabolism', enrichmentScore: 2.9, pValue: 0.0028, genes: 15 },
            { pathway: 'Cell cycle regulation', enrichmentScore: 2.1, pValue: 0.0089, genes: 7 }
        ]
    };

    return (
        <div className="OmicsView-transcriptome-report">
            <h3>Transcriptome Report for {id}</h3>
            <div className="OmicsView-transcriptome-content">
                <div className="OmicsView-transcriptome-section">
                    <h4>
                        <FontAwesomeIcon icon={faCircleNodes} /> Expression Summary
                    </h4>
                    <div className="OmicsView-transcriptome-summary">
                        <div className="OmicsView-transcriptome-summary-item up">
                            <div className="OmicsView-transcriptome-summary-icon">
                                <FontAwesomeIcon icon={faArrowUp} />
                            </div>
                            <div className="OmicsView-transcriptome-summary-count">
                                {transcriptomeData.expressionProfile.upregulated}
                            </div>
                            <div className="OmicsView-transcriptome-summary-label">
                                Upregulated Genes
                            </div>
                        </div>
                        <div className="OmicsView-transcriptome-summary-item down">
                            <div className="OmicsView-transcriptome-summary-icon">
                                <FontAwesomeIcon icon={faArrowDown} />
                            </div>
                            <div className="OmicsView-transcriptome-summary-count">
                                {transcriptomeData.expressionProfile.downregulated}
                            </div>
                            <div className="OmicsView-transcriptome-summary-label">
                                Downregulated Genes
                            </div>
                        </div>
                        <div className="OmicsView-transcriptome-summary-item unchanged">
                            <div className="OmicsView-transcriptome-summary-icon">
                                <FontAwesomeIcon icon={faEquals} />
                            </div>
                            <div className="OmicsView-transcriptome-summary-count">
                                {transcriptomeData.expressionProfile.unchanged}
                            </div>
                            <div className="OmicsView-transcriptome-summary-label">
                                Unchanged Genes
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="OmicsView-transcriptome-section">
                    <h4>Top Differentially Expressed Genes</h4>
                    <div className="OmicsView-transcriptome-genes">
                        <table className="OmicsView-transcriptome-table">
                            <thead>
                                <tr>
                                    <th>Gene</th>
                                    <th>Fold Change</th>
                                    <th>p-Value</th>
                                    <th>Regulation</th>
                                    <th>Pathway</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transcriptomeData.significantGenes.map((gene, index) => (
                                    <tr key={index}>
                                        <td>{gene.gene}</td>
                                        <td>{gene.foldChange > 0 ? '+' : ''}{gene.foldChange.toFixed(1)}</td>
                                        <td>{gene.pValue.toExponential(2)}</td>
                                        <td className={`regulation-${gene.regulation}`}>
                                            <FontAwesomeIcon 
                                                icon={gene.regulation === 'up' ? faArrowUp : faArrowDown} 
                                            /> {gene.regulation}
                                        </td>
                                        <td>{gene.pathway}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <div className="OmicsView-transcriptome-section">
                    <h4>Pathway Enrichment Analysis</h4>
                    <div className="OmicsView-transcriptome-pathways">
                        {transcriptomeData.pathwayEnrichment.map((pathway, index) => (
                            <div key={index} className="OmicsView-transcriptome-pathway">
                                <div className="OmicsView-transcriptome-pathway-name">
                                    {pathway.pathway}
                                </div>
                                <div className="OmicsView-transcriptome-pathway-bar-container">
                                    <div 
                                        className="OmicsView-transcriptome-pathway-bar"
                                        style={{ width: `${Math.min(100, pathway.enrichmentScore * 15)}%` }}
                                    ></div>
                                </div>
                                <div className="OmicsView-transcriptome-pathway-score">
                                    Score: {pathway.enrichmentScore.toFixed(1)}
                                </div>
                                <div className="OmicsView-transcriptome-pathway-details">
                                    p={pathway.pValue.toExponential(2)} | {pathway.genes} genes
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TranscriptomeReport;
